import LocalStorage from '../data/local-storage';
import IndexedDB from '../data/indexed-db';
import AuthService from './auth-service';
import { escapeHtml, formatTimeAgo } from '../utils/helpers';
import * as UIService from './ui-service';

class NotificationService {
  constructor() {
    this.notifications = [];
  }

  async load() {
    const existing = this.notifications.slice();
    const stored = await IndexedDB.get(this.getKey());
    let combined = Array.isArray(stored)
      ? [...existing, ...stored]
      : [...existing, ...(LocalStorage.getUserSpecificObject('heliaedu_user_notifications', AuthService.user.id) || [])];
    const pending = await IndexedDB.get('pending_notifications');
    if (pending && Array.isArray(pending)) {
      combined = [...pending, ...combined];
      await IndexedDB.remove('pending_notifications');
    }
    this.notifications = combined.slice(0, 50);
    if (this.notifications.length > 0) {
      await IndexedDB.set(this.getKey(), this.notifications);
      LocalStorage.setUserSpecificObject(
        'heliaedu_user_notifications',
        AuthService.user.id,
        this.notifications
      );
    }
  }

  getKey() {
    return LocalStorage.getUserSpecificKey('heliaedu_user_notifications', AuthService.user.id);
  }

  getNotifications() {
    return this.notifications;
  }

  setNotifications(notifs) {
    this.notifications = notifs;
    IndexedDB.set(this.getKey(), notifs);
    LocalStorage.setUserSpecificObject(
      'heliaedu_user_notifications',
      AuthService.user.id,
      notifs
    );
  }

  removeNotification(id) {
    const notifs = this.getNotifications().filter(n => n.id !== id);
    this.setNotifications(notifs);
    this.updateBubble();
  }

  addNotification(notification) {
    const notifs = [notification, ...this.getNotifications()];
    if (notifs.length > 50) notifs.length = 50;
    this.setNotifications(notifs);
    this.updateBubble();
    return notification;
  }

  updateBubble() {
    const list = document.querySelector('#notification-list');
    const empty = document.querySelector('#notification-empty');
    const wrapper = document.querySelector('.notification-wrapper-tick');
    if (!list || !empty || !wrapper) return;
    const notifs = this.getNotifications();
    list.innerHTML = '';
    let badge = wrapper.querySelector('.notification-badge');
    if (notifs.length === 0) {
      list.style.display = 'none';
      empty.style.display = 'flex';
      if (badge) badge.remove();
      return;
    }
    empty.style.display = 'none';
    list.style.display = 'flex';
    const recent = notifs.sort((a,b) => new Date(b.timestamp)-new Date(a.timestamp)).slice(0,5);
    recent.forEach(n => {
      const timeAgo = formatTimeAgo(n.timestamp);
      list.innerHTML += `<div class="notification-item"><div class="notification-sender"><div class="notification-icon"><span class="material-symbols-rounded" aria-hidden="true">notifications</span></div><div class="notification-name"><strong>${n.title}</strong><p>${timeAgo}</p></div></div><div class="preview-notification"><p>${escapeHtml(n.message).substring(0,50)}${n.message.length>50?'...':''}</p></div></div>`;
    });
    const count = notifs.length;
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'notification-badge';
      wrapper.appendChild(badge);
    }
    badge.textContent = count > 9 ? '9+' : count;
    UIService.reinitTooltips();
  }
}

export default new NotificationService();
